
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';
import { blogPosts } from '../../mocks/blogPosts';

const BlogPage = () => {
  useEffect(() => {
    document.title = 'Blog - İzmir Tente Tamir | Tente Bakım ve Tamir İpuçları';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Tente bakımı, tamir ipuçları ve doğru tente seçimi hakkında faydalı bilgiler. İzmir Tente Tamir blog sayfası.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <section className="pt-20 pb-10 md:pt-24 md:pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Blog &amp; Haberler
            </h1>
            <p className="text-sm text-gray-600 max-w-2xl mx-auto">
              Tente bakımı, tamir ipuçları ve sektör haberleri hakkında faydalı bilgiler
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {blogPosts.map((post) => (
              <article key={post.id} className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow duration-300">
                <div className="w-full h-40 md:h-48 bg-gray-100">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="p-4">
                  <div className="inline-block px-2 py-0.5 bg-gray-100 rounded-full text-xs font-medium text-gray-700 mb-2">
                    {post.category}
                  </div>
                  <h2 className="text-sm md:text-base font-bold text-gray-900 mb-2 leading-tight">
                    {post.title}
                  </h2>
                  <p className="text-xs text-gray-600 mb-3 leading-relaxed line-clamp-2">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">{post.date}</span>
                    <Link
                      to={`/blog/${post.slug}`}
                      className="inline-flex items-center text-xs font-medium text-gray-900 hover:text-gray-700 transition-colors cursor-pointer"
                    >
                      Oku
                      <i className="ri-arrow-right-line ml-1"></i>
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
